import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import {
  addEditServiceRequest,
  deleteServiceRequest
} from "../../../commons/ServiceRequest";
import RecordRepairForm from "../../../components/RepairWork/RecordRepairForm";
import FileUploadsService from "../../../services/fileupload.service";
import InformRepairJobsService from "../../../services/informrepairjob.service";
import InformRepairItemsService from "../../../services/informrepairitem.service";
import InformRepairFilesService from "../../../services/informrepairfile.service";

export default function CreateRequisition() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const commonNavigatePage = (Repair_Id) => {
    const SearchValue = [
      {
        name: "id",
        labelName: "repair_doc_no",
        label: "หมายเลขแจ้งซ่อม",
        value: `${Repair_Id}`
      }
    ];
    navigate(pathname, { state: { name: "search", SearchValue } });
    navigate(0);
  };

  const handleSubmit = ({ Repair, Item, Media, DeleteData }) => {
    const {
      id,
      admin_brand_items,
      approve_items,
      concern_customer_items,
      deleted,
      iss_job_items,
      job_type_items,
      job_type_sub_items,
      repair_job_files,
      sub_cus_items,
      tech_sub_items,
      ...modifiedRepair
    } = Repair;
    const files = [
      ...Media.Image.filter((item) => item instanceof File),
      ...Media.Video.filter((item) => item instanceof File)
    ];
    const navigatePage =
      files?.length > 0
        ? "Media"
        : Item?.array.some(({ item_id }) => item_id)
        ? "Item"
        : "Repair";

    handleDeleteData(DeleteData);

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformRepairJobsService.editInformRepairJobs(
        id,
        modifiedRepair
      ),
      callback: () => {
        if (Item?.array.some(({ item_id }) => item_id)) {
          handleSubmitItem({ Item, inform_repair_id: id, navigatePage });
        }
        if (files.length > 0) {
          handleUploadFile({
            files,
            inform_repair_id: id,
            navigatePage,
            destination: "ใบแจ้งซ่อม/Media",
            company_code: Repair.company_code
          });
        }
      },
      navigated: (navi) =>
        navi && navigatePage === "Repair" && commonNavigatePage(id)
    });
  };

  const handleSubmitItem = ({ Item, inform_repair_id, navigatePage }) => {
    Item.array.map(({ id, repair_items, dt_mas_items, deleted, ...item }) =>
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: id
          ? InformRepairItemsService.editInformRepairItems(id, item)
          : InformRepairItemsService.createInformRepairItems({
              array: [{ ...item, inform_repair_id }]
            }),
        navigated: (navi) =>
          navi &&
          navigatePage === "Item" &&
          commonNavigatePage(inform_repair_id)
      })
    );
  };

  const handleUploadFile = ({
    destination,
    files,
    inform_repair_id,
    company_code,
    navigatePage
  }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads(destination, files),
      callback: ({ files }) => {
        const InformFiles = {
          array: files.map((file) => ({
            company_code,
            inform_repair_id,
            file_path: `${destination}/${file}`,
            file_type: ["jpg", "jpeg", "png"].includes(file.split(".").pop())
              ? "Image"
              : "Video"
          }))
        };
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest:
            InformRepairFilesService.createInformRepairFiles(InformFiles)
        });
      },
      navigated: (navi) =>
        navi && navigatePage === "Media" && commonNavigatePage(inform_repair_id)
    });
  };

  const handleDeleteData = ({ Item, Media }) => {
    if (Item?.length > 0) {
      Item.map(({ id }) =>
        deleteServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: InformRepairItemsService.deleteInformRepairItems(
            id,
            true
          )
        })
      );
    }
    if (Media?.length > 0) {
      Media.map(({ id, file_path }) => {
        const lastSlashIndex = file_path.lastIndexOf("/");
        const des = file_path.substring(0, lastSlashIndex);
        const name = file_path.substring(lastSlashIndex + 1);
        deleteServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: InformRepairFilesService.deleteInformRepairFiles(id)
        });
        deleteServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: FileUploadsService.deleteFileUploads(des, name)
        });
      });
    }
  };

  return <RecordRepairForm onSubmitCallback={handleSubmit} />;
}
